var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    ref: "vueModal",
    attrs: {
      "name": _vm.modalName,
      "pivotY": 0.15,
      "max-width": _vm.maxWidthModal,
      "width": _vm.widthModal,
      "height": _vm.height,
      "adaptive": true,
      "scrollable": false,
      "click-to-close": _vm.clickToClose,
      "classes": ['generic-modals', 'v--modal', 'new-modal', _vm.modalClasses],
      "role": "dialog",
      "aria-modal": "true",
      "aria-describedby": _vm.dialogDesc && 'dialog-desc',
      "aria-labelledby": (_vm.showHeaderAria || _vm.showStepsView || _vm.headerTitle) && 'customs-vmodal-header-title'
    },
    on: {
      "before-open": _vm.beforeOpenAction,
      "before-close": _vm.beforeCloseAction,
      "closed": _vm.closedModal
    }
  }, [_c('focus-trap', {
    attrs: {
      "active": _vm.focusTrapState
    }
  }, [_c('section', {
    class: ['new-modal-wrapper', 'customs-tools', {
      'new-modal-wrapper-no-buttons': !_vm.ctaPrimaryButton || !_vm.isCtaPrimaryButtonVisible
    }]
  }, [_c('div', {
    staticClass: "new-modal-top-nav"
  }, [_c('div', {
    attrs: {
      "slot": "top-left"
    },
    slot: "top-left"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isBackButtonVisible,
      expression: "isBackButtonVisible"
    }],
    staticClass: "new-modal-top-nav-back",
    attrs: {
      "type": "button",
      "disabled": _vm.disableButtons || _vm.disableNextBackButtons,
      "title": "Back",
      "aria-label": _vm.translations.ugcModalBack,
      "role": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-back.svg"),
      "aria-hidden": "true"
    }
  })], 1)]), _c('modal-top-nav', {
    attrs: {
      "headerImg": _vm.headerImg,
      "headerTitle": _vm.headerTitle,
      "showStepsView": _vm.showStepsView
    }
  }), _vm.showCloseIcon ? _c('div', {
    attrs: {
      "slot": "top-right"
    },
    slot: "top-right"
  }, [_c('button', {
    staticClass: "new-modal-top-nav-close",
    attrs: {
      "type": "button",
      "disabled": _vm.disableButtons && !_vm.disableCloseButton,
      "id": "close-button-".concat(_vm.modalName),
      "title": "Close",
      "aria-label": _vm.translations.profanityCheckClose,
      "role": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.closeAction();
      }
    }
  }, [_c('customs-svg-icon', {
    attrs: {
      "src": "".concat(_vm.assetsPath, "/svg/customizer/icon-close.svg"),
      "aria-hidden": "true"
    }
  })], 1)]) : _vm._e()], 1), _c('section', {
    staticClass: "new-modal-main-views-wrapper"
  }, [_vm.title ? _c('h2', {
    staticClass: "new-modal-title"
  }, [_vm._v(_vm._s(_vm.translations[_vm.title]))]) : _vm._e(), _vm.description ? _c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v(_vm._s(_vm.translations[_vm.description]))]) : _vm._e(), _vm._t("default", null, {
    "contentProps": _vm.contentProps
  })], 2), _c('modal-button-nav', {
    ref: "modalButtonNav",
    attrs: {
      "cta-primary-button": _vm.ctaPrimaryButton,
      "cta-secondary-button": _vm.ctaSecondaryButton,
      "show-icon-button": _vm.isIconButtonVisible,
      "cta-primary-button-icon-name": _vm.ctaPrimaryButtonIconName,
      "cta-primary-button-icon-type": _vm.ctaPrimaryButtonIconType,
      "show-cta-secondary-button": _vm.isCtaSecondaryButtonVisible,
      "show-cta-primary-button": _vm.isCtaPrimaryButtonVisible,
      "block-cta-primary-button": _vm.isCtaPrimaryBlocked || _vm.disableButtons || _vm.disableNextBackButtons,
      "block-cta-secondary-button": _vm.isCtaSecondaryBlocked || _vm.disableButtons,
      "cta-primary-tooltip": _vm.ctaPrimaryTooltip,
      "cta-secondary-tooltip": _vm.ctaSecondaryTooltip
    },
    on: {
      "ctaSecondaryAction": _vm.ctaSecondaryAction,
      "ctaPrimaryAction": _vm.ctaPrimaryAction
    }
  })], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }